import type { QuickFillItem } from '../../../shared/types';
import type { TableInitialPreset } from '../../../shared/ui/table/hooks/useTableFilters';
import { resolveColumnKey } from '../../../shared/lib/table/columnMapping';
import type { ValidationQuickFillFocus } from '../../../shared/types/validationNavigation.types';

export * from './quickFillLabelNormalization';
export * from './quickFillScopeFiltering';
export * from './quickFillFocusResolution';

export function buildQuickFillFocusPreset(
  focus: ValidationQuickFillFocus,
  rowNames: string[],
  data: QuickFillItem[]
): TableInitialPreset | null {
  const exactNameFilters = Array.from(new Set(rowNames.map((rowName) => rowName.trim()).filter(Boolean)));
  if (exactNameFilters.length === 0) {
    return null;
  }

  const sortColumn = focus.primaryLabel
    ? (resolveColumnKey(focus.primaryLabel) as keyof QuickFillItem)
    : null;
  const canSortByPrimaryLabel =
    sortColumn &&
    data.length > 0 &&
    data.some((item) => Object.prototype.hasOwnProperty.call(item, sortColumn));

  return {
    requestId: focus.requestId || `quickfill-focus-${Date.now()}`,
    exactNameFilters,
    ...(canSortByPrimaryLabel
      ? {
          sort: {
            column: sortColumn,
            direction: 'asc',
            missingValuePlacement: 'first',
          },
        }
      : {}),
  };
}
